<template>
  <!-- 법인 온실가스 배출량 -->
  <esg-base-dashboard-card title="온실가스 배출량 "
                           :subtitle="`(법인A~D - ${currentYear}년)`">
    <b-row align-h="around">
      <template v-for="corporation in corporations">
        <b-col :key="corporation.code"
               md="4"
               lg="3">
          <emission-by-scope-for-corp :corporation="corporation"
                                      @dataPointSelection="onDataPointSelection"/>
        </b-col>
      </template>
    </b-row>
    <b class="annotation">사업장별 세부정보를 보시려면 그래프를 클릭해주세요</b>
  </esg-base-dashboard-card>
  <!-- /법인 온실가스 배출량 -->
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EmissionByScopeForCorp from "../charts2/CorpEmissionByScope.vue";

export default {
  components: {
    EsgBaseDashboardCard,
    EmissionByScopeForCorp,
  },
  created() {
    this.fetchCorps();
  },
  data() {
    return {
      corporations: []
    }
  },
  methods: {
    async fetchCorps() {
      try {
        let response = await axios.get('esg/lca/tables/esg_base_corporation', {
          headers: {Authorization: accessToken()}
        });

        this.corporations = response.data.list;
      } catch (error) {
        await this.showError(error);
      }
    },
    onDataPointSelection(corporation) {
      this.$emit('dataPointSelection', corporation)
    }
  }
}
</script>

<style scoped>
.subtitle {
  font-family: NanumGothic, serif;
  font-weight: bold;
  font-size: 1rem;
  padding-bottom: .5rem;
}

.annotation {
  font-size: 10px;
  font-weight: 500;
  font-family: NanumGothic;
  color: #888;
}
</style>